/**
 * @file
 * Attaches behaviors for News Paragraph
 */

!((Drupal, $) => {

  'use strict';
  Drupal.behaviors.paragraphNews = {

    attach: function (context) {

      /**
       * Enable slick carousel
       * @param {object} $slickContainer the item container
       * @returns {void}
       */
      function enableSlickCarousel($slickContainer) {
        $slickContainer.slick({
          // eslint-disable-next-line max-len
          nextArrow: '<button uk-icon="icon: chevron-right; ratio: 1.2;" class="slick-next uk-icon uk-button-icon" aria-label="' + Drupal.t('Actualité suivante') + '"></button>',
          // eslint-disable-next-line max-len
          prevArrow: '<button uk-icon="icon: chevron-left; ratio: 1.2;" class="slick-prev uk-icon uk-button-icon" aria-label="' + Drupal.t('Actualité précédente') + '"></button>',
          arrows: true,
          dots: false,
          infinite: true,
          slidesToShow: 3,
          slidesToScroll: 3,
          centerMode: false,
          responsive: [
            {
              breakpoint: 960,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 2,
              }
            },
            {
              breakpoint: 640,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
              }
            }
          ]
        });
      }

      $(context).find('.js-latest-news-slick-slider').each(function () {
        enableSlickCarousel($(this));

        // Place buttons.
        var marginObj = $(context).find('.paragraph--type--news .layout-inner-container');
        var margin = parseInt(marginObj.css('margin-left'));
        var padding = parseInt(marginObj.css('padding-left'));
        $(this).find('.slick-prev').css('left', '-' + (margin + padding) + 'px');
        $(this).find('.slick-next').css('right', '-' + (margin + padding) + 'px');
      });



    }
  };
// eslint-disable-next-line no-undef
})(Drupal, jQuery);

